// @generated by scripts/gen-modules.mjs
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import { ModuleGuard } from '@shared/module-kit';

const GlAuditTrailPage = lazy(() => import('./pages/GlAuditTrailPage'));
const SegregationOfDutiesPage = lazy(() => import('./pages/SegregationOfDutiesPage'));
const RetentionPoliciesPage = lazy(() => import('./pages/RetentionPoliciesPage'));
const CertificationsPage = lazy(() => import('./pages/CertificationsPage'));

export const ComplianceRoutes: RouteObject = {
  path: 'compliance',
  element: <ModuleGuard moduleId="finance.compliance" />,
  children: [
    { path: 'gl-audit-trail', element: <GlAuditTrailPage />, handle: { crumb: 'Gl Audit Trail' } },
    { path: 'segregation-of-duties', element: <SegregationOfDutiesPage />, handle: { crumb: 'Segregation Of Duties' } },
    { path: 'retention-policies', element: <RetentionPoliciesPage />, handle: { crumb: 'Retention Policies' } },
    { path: 'certifications', element: <CertificationsPage />, handle: { crumb: 'Certifications' } },
  ],
};
